import { Link } from 'react-router-dom';
import { relatedPages } from '@/mocks/masterCourseData';
import { useTranslation } from 'react-i18next';

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).map((paragraph, i) => (
    <p key={i} className={className}>
      {paragraph}
    </p>
  ));
}

export default function RelatedPages() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          {String(t('coursesMaster.related.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesMaster.related.title')}
          </h2>
          <div className="gold-line mx-auto"></div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {relatedPages.slice(0, 3).map((page, index) => (
            <Link key={index} to={page.href} className="card-glow bg-background-50 border border-background-200/60 p-6 group cursor-pointer">
              <h4 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-2 group-hover:text-accent-600 transition-colors duration-300">
                {t(`coursesMaster.related.${index}.title`)}
              </h4>
              {renderParagraphs(
                t(`coursesMaster.related.${index}.description`),
                'text-[15px] text-foreground-600 leading-relaxed tracking-[0.03em] mb-4'
              )}
              <span className="inline-flex items-center gap-1 text-[13px] text-accent-600 tracking-[0.08em]">
                <span>{t('coursesMaster.related.viewDetail')}</span>
                <i className="ri-arrow-right-line text-[12px] transition-transform duration-300 group-hover:translate-x-1"></i>
              </span>
            </Link>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5 max-w-2xl mx-auto">
          {relatedPages.slice(3).map((page, index) => (
            <Link key={index} to={page.href} className="card-glow bg-background-50 border border-background-200/60 p-6 group cursor-pointer">
              <h4 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-2 group-hover:text-accent-600 transition-colors duration-300">
                {t(`coursesMaster.related.${index + 3}.title`)}
              </h4>
              {renderParagraphs(
                t(`coursesMaster.related.${index + 3}.description`),
                'text-[15px] text-foreground-600 leading-relaxed tracking-[0.03em] mb-4'
              )}
              <span className="inline-flex items-center gap-1 text-[13px] text-accent-600 tracking-[0.08em]">
                <span>{t('coursesMaster.related.viewDetail')}</span>
                <i className="ri-arrow-right-line text-[12px] transition-transform duration-300 group-hover:translate-x-1"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
